import React, { Component } from "react";
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import {
  MuiPickersUtilsProvider,
  InlineDatePicker
} from "material-ui-pickers";
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { MuiThemeProvider } from "@material-ui/core";
import InputAdornment from '@material-ui/core/InputAdornment';
import "moment/locale/es";
import ModalNoLaborable from './error/ModalNoLaborable';
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios';
import $ from 'jquery';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

// persistencia en redux
import {
  setValorCampoSimulador,
  setPlazoDiasSimulador,
  setRespuestaSimularSimulador,
  setParametriaSimulador,
  resetSimulador
} from '../../../actions/actions';

import { connect } from 'react-redux';

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  card: {
    borderRadius: "20px",
    padding: "20px",
  },
  picker: {
    '& button': {
      padding: '0 !important'
    }
  },
  simularButon:{
    //marginLeft: "-20px !important"
  },
  card: {
    borderRadius: "20px",
    padding: "20px",
    paddingBottom: "10px",
    background: "#e4e4e4 !important",
    boxShadow: "none"
  },
  picker: {
    '& button': {
      padding: '0 !important'
    },
    width: "100% !important"
  },
  simulador: {
    marginTop: "25px"
  },
  volverAsimular: {
    height: "16px",
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: "normal",
    fontStyle: "normal",
    fontStretch: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#f37321",
    paddingLeft: "3px !important",
    marginTop: "20px",
    textTransform: "uppercase"
  },
  input: {
    height: "24px",
    fontFamily: "Roboto",
    fontSize: "20px",
    fontWeight: "normal",
    fontStyle: "normal",
    fontStretch: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#4a4a4a"
  },
  interesCobrar: {
    fontSize: "14px",
    color: "#a7a7a7"
  },
  interesSimulador: {
    fontSize: "28px",
    color: "#4a4a4a",
    fontWeight: "bold"
  },
  montoSimulador: {
    fontWeight: "normal"
  },
  tnaSimulador: {
    fontSize: "18px",
    color: "#a7a7a7"
  },
  montoPlazoFechaLabel: {
    opacity: "0.7",
    fontSize: "12px",
    color: "#9b9b9b"
  },
  montoPlazoFechaHelperText: {
    opacity: "0.7",
    fontSize: "10px",
    color: "#9b9b9b"
  },
  '@media  screen and (max-width: 600px)': {
    interesSimulador: {
      height: "24px !important",
      fontSize: "20px !important"
    },
    montoSimulador: {
      height: "21px !important",
      fontSize: "18px !important"
    },
    tnaSimulador: {
      fontSize: "14px !important",
      fontWeight: "normal !important",
      color: "#9b9b9b !important"
    },
    interesCobrar: {
      color: "#9b9b9b !important"
    },
    montoPlazoFechaLabel: {
      opacity: "1"
    },
    fechaLabelMobile: {
      opacity: "0.6"
    },
    montoPlazoFechaHelperText: {
      opacity: "1",
      fontSize: "10px"
    }
  },
  '@media  screen and (max-width: 959px)': {
    plazoDiasEspacioMobile: {
      marginTop: "15px",
      marginBottom: "15px",
    },
    alignItemRight: {
      textAlign: 'right'
    },
    interesMontoTna: {
      color: "#9b9b9b"
    }
  },
  botonSimular:{
    marginLeft:"-19px",
    marginTop:"15px"
  },
  '@media screen and (min-width: 960px)': {
    selectPlazoFijoTipo: {
      marginBottom: "25px",
    }
  }
});


class Simulador extends Component {
  constructor(props) {
    super(props);
    moment.locale('esp');
    this.state = {
      errorDiaNoLaborable: false,
      locale: 'es',
      montoMin: 0,
      montoMax: 0,
      plazoMin: 0,
      plazoMax: 0,
      monto:null,
      plazo:null,
      plazoDias:null,
      ready:false,
      tipoPlazoFijo:"",
      tiposPlazoFijo:[
        {id:1,descripcion:"Tradicional en pesos"},
        {id:2,descripcion:"Ajustable por UVA Precancelable"}
      ]
    }

    this.handleChange = this.handleChange.bind(this);
    this.cerrarModal = this.cerrarModal.bind(this);
    this.handleSimulacion = this.handleSimulacion.bind(this);
    this.handleSimulacion2 = this.handleSimulacion2.bind(this);
    this.getTextoBoton = this.getTextoBoton.bind(this);
    this.getVarsContext = this.getVarsContext.bind(this);
    this.huboSimulacion = this.huboSimulacion.bind(this)
    this.huboSimulacionLanding = this.huboSimulacionLanding.bind(this)
    this.huboSimulacionSimulador = this.huboSimulacionSimulador.bind(this)
    this.getErrorMessages = this.getErrorMessages.bind(this)
    this.setTipoParametria = this.setTipoParametria.bind(this)
    
  }
  
  setTipoParametria(tipoPlazoFijo){

    if(tipoPlazoFijo === 1){
    
      let { parametria } = this.props.plazoFijoLandingPage

      this.props.setParametriaSimulador({
          montoMin: Number(parametria.montoMinimoSimulacion),
          montoMax: Number(parametria.montoMaximoSimulacion),
          plazoMin: Number(parametria.plazoMinimoSimulacion),
          plazoMax: Number(parametria.plazoMaximoSimulacion),
          tna: Number(parametria.tna),
      });

    }else{
      let { parametriaUvas, parametria } = this.props.plazoFijoLandingPage

      this.props.setParametriaSimulador({
          montoMin: Number(parametriaUvas.montoMin),
          montoMax: Number(parametriaUvas.montoMax),
          plazoMin: Number(parametriaUvas.plazoMin),
          plazoMax: Number(parametriaUvas.plazoMax),
          tna: Number(parametria.tna),
      });
    }
  }

  componentWillMount() {
    let tipoPlazoFijo = this.props.plazoFijoLandingPage.data.tipoPlazoFijo || 1
    //para manejar la validacion
    this.setTipoParametria(tipoPlazoFijo)
    
    //en landind se usa plazo, 
    //en simulador se usa plazoDias como contador, plazo como string para el datepicker
    let { monto = 0, plazo = 0 } = this.props.plazoFijoLandingPage.data
    
    if(monto > 0){
      //HUBO SIMULACION
      this.props.setValorCampoSimulador({
        fieldName:"huboSimulacion",
        fieldValue:true
      })

      //si el monto es mayor a cero significa que hubo una simulacion previa
      //y dichos parametros satisfacen las validaciones necesarias
      this.handleSimulacion(monto,plazo,false)
    }

    let oldSimuladorState = {
      monto : null,
      plazoDias : null,
      plazo : null
    }

    //si viene con datos de la landing
    if(monto > 0){
      oldSimuladorState.monto = monto
      oldSimuladorState.plazoDias = plazo
      oldSimuladorState.plazo =  moment().add(Number( plazo ), 'days')
    }

    //si c recargo la pagina
    if( this.props.simulador.monto > 0 ){
      oldSimuladorState.monto = this.props.simulador.monto
      oldSimuladorState.plazoDias = this.props.simulador.plazoDias
      oldSimuladorState.plazo =  moment().add(Number( this.props.simulador.plazoDias ), 'days')
    }

    this.setState({
      monto: oldSimuladorState.monto,
      plazoDias: oldSimuladorState.plazoDias,
      plazo: oldSimuladorState.plazo,
      ready: true,  //este codigo se ejecuta asyncronicamente despues la busqueda de parametria por lo el ocmponente sera montado en un estado invalido, con este flag freno la validacion hasta q se carguen los datos :)
      tipoPlazoFijo
    })

    this.props.setValorCampoSimulador({
      fieldName:"huboCambios",
      fieldValue:false
    })

    this.props.setValorCampoSimulador({
      fieldName:"tipoPlazoFijo",
      fieldValue:tipoPlazoFijo
    })
    
  }

  handleSimulacion2() {
    this.handleSimulacion(this.state.monto,this.state.plazoDias)
  }


  handleSimulacion(monto,plazoDias,animation = true) {
    let tipo = (this.state.tipoPlazoFijo === 1)? "PESOS" : "UVAS" 

    let data = {
      "monto":  monto,
      "plazo":  plazoDias,
      tipo
    }
      if(animation){
        $('.load').fadeIn(700);
      }
      axios.post(`${localStorage.getItem('url')}/api/plazoFijo/simular?codigoPostal=${this.props.plazoFijoInformacionDomicilio.codigo}`, data,{withCredentials: true})
        .then((response) => {

          let data = { 
            intereses: response.data.totalInteresEstimado,
            tasa: response.data.tasa,
            montovencimiento: response.data.totalInteresEstimado + response.data.capital,
            monto: response.data.capital,
            plazoDias: plazoDias,
            plazo:  moment().add(Number( plazoDias ), 'days'),
            huboSimulacion : true,
            validMonto:response.data.capital,
            validPlazoDias:plazoDias,
            tipoPlazoFijo: this.state.tipoPlazoFijo
          }

          if( this.state.tipoPlazoFijo === 2 ){
            data = {
              ...data,
              cotizacionUva: response.data.cotizacionUVA,
              montoInicialUva:  response.data.montoUVA,
              tnaCancelacionAnt:  response.data.tnaCancelacionAnt,
              teaCancelacionAnt:  response.data.teaCancelacionAnt
            }
          }

          this.props.setRespuestaSimularSimulador(data)

          if(animation){
            $('.load').fadeOut(700);
          }

        }).catch((err) => {
          if(animation){
            $('.load').fadeOut(700);
          }
        })
  }
  
   handleChange(event) {
    event.preventDefault();
    const name = event.target.name;
    const value = event.target.value
    const esNumero = /^[0-9]+$/;

    if(!this.props.simulador.huboCambios){
      this.props.setValorCampoSimulador({
        fieldName:"huboCambios",
        fieldValue:true
       })
    }

    if (esNumero.test(event.target.value) || event.target.value === "") {
      switch (name) {
        case 'monto':
           this.setState({monto:value})
           let monto = value
           //value = monto, si el valor es distinto a uno valido calculado anteriormente
           //lo mato para forzar la validacion posterior, idem con la fecha


           if(monto != this.props.simulador.validMonto){
            monto = 0
          }

          this.props.setValorCampoSimulador({
            fieldName:"monto",
            fieldValue:monto
           })

          break;
        case 'plazoDias':
           let data = {
            plazoDias:value,
            plazo: moment().add(Number( value ), 'days')
           }

           this.setState({
            plazoDias:data.plazoDias,
            plazo: data.plazo
           })

          let plazoDiasRedux = value
          //si el nuevo valor es igual a uno previamente calculado lo persito
          //sino lo mato forzando una nueva eventual validacion
          if(plazoDiasRedux !== this.props.simulador.validPlazoDias){
            data.plazoDias = 0
            data.plazo = ""
          }

          this.props.setPlazoDiasSimulador(data)    

          break;
        case 'tipoPlazoFijo':
          this.setTipoParametria(event.target.value)
          
          this.props.resetSimulador({tipoPlazoFijo:event.target.value})

          let {plazoDias} = this.state
                
          console.log("this.props.plazoFijoLandingPage")
          console.log(this.props.plazoFijoLandingPage)

          if(event.target.value === 2){
              if(plazoDias < this.props.plazoFijoLandingPage.parametriaUvas.plazoMin){
                plazoDias = this.props.plazoFijoLandingPage.parametriaUvas.plazoMin
              }

              this.props.setRespuestaSimularSimulador({cotizacionUva:"",montoInicialUva:""})

          }else{
              //PF tradicional
              if(this.state.plazoDias > this.props.plazoFijoLandingPage.parametria.plazoMaximoSimulacion){
                plazoDias = this.props.plazoFijoLandingPage.parametria.plazoMaximoSimulacion
              }else{
                plazoDias = this.state.plazoDias
              }

              if(monto > Number(this.props.plazoFijoLandingPage.parametria.montoMaximoSimulacion) ){
                  monto =  Number(this.props.plazoFijoLandingPage.parametria.montoMaximoSimulacion)
              }
          }

          let plazo = moment().add(plazoDias,'days')

          this.setState({
            tipoPlazoFijo:event.target.value,
            plazoDias,
            plazo
          })

        default:
          break;
      }
    }
  }

  
  handleChangeDate = (event) => {
    if(!this.props.simulador.huboCambios){
      this.props.setValorCampoSimulador({
        fieldName:"huboCambios",
        fieldValue:true
       })
    }

    let dias = event.diff(moment(), 'days') + 1; //le sumo uno porque siempre da un dia de menos

    this.props.setPlazoDiasSimulador({
      plazoDias:dias,
      plazo: event 
    })    

    this.setState({
      plazoDias:dias,
      plazo: event 
     })
  }


  isWeekend(event) {
    const fecha = event;
    return fecha.day() === 0 || fecha.day() === 6;
  }

  cerrarModal(dataModal) {
    this.setState({ errorDiaNoLaborable: dataModal });
  }

  isDataOk(){
    return false
  }

  getTextoBoton(){
    let {huboSimulacion} = this.props.simulador

    let texto = "Volver a simular"
    if(!huboSimulacion){
      texto = "simular"
    }
    return texto
  }

  huboSimulacionLanding(){
    const {plazoFijoLandingPage} = this.props

    return plazoFijoLandingPage.data !== ""
  }

  huboSimulacionSimulador(){
    const {simulador} = this.props
    return simulador.monto > 0
  }

  huboSimulacion(){
    return this.huboSimulacionLanding() || this.huboSimulacionSimulador()
  }

  getVarsContext(){
    let mostrarDetalleSimulacion=false,
        tasa="",
        montovencimiento="",
        intereses="";

    const {simulador} = this.props;

    if( this.huboSimulacion() ){

      if( this.huboSimulacionSimulador() ){
        mostrarDetalleSimulacion = true
        tasa=simulador.tasa
        montovencimiento=simulador.montovencimiento
        intereses=simulador.intereses
      }
    }
    
    return {
      mostrarDetalleSimulacion,
      tasa,
      montovencimiento,
      intereses
    }
  }

  getErrorMessages(){
    const {simulador} = this.props;

    let errorMontoMin=false,
        errorMontoMax=false,
        errorPlazoMinimo=false,
        errorPlazoMaximo=false,
        errorPlazoFinDeSemana="",
        mensajeErrorMonto="",
        mensajeErrorPlazo="",
        mensajePickerPlazoMinimo="",
        mensajePickerPlazoMaximo="",
        mensajeFechaFinDeSemana="",
        isWeekend=false,
        disableSubmit = true;
    
        //initial state
    if( !this.state.ready ){
        return {
          errorMontoMin,
          errorMontoMax,
          errorPlazoMinimo,
          errorPlazoMaximo,
          mensajeErrorMonto,
          mensajeErrorPlazo,
          mensajePickerPlazoMinimo,
          mensajePickerPlazoMaximo,
          errorPlazoFinDeSemana,
          mensajeFechaFinDeSemana,
          disableSubmit
        } 
    }

    if( this.state.monto !== null ){
      errorMontoMin = this.state.monto < simulador.montoMin;
      errorMontoMax = this.state.monto >= simulador.montoMax;  

    }

    if( this.state.plazoDias !== null ){
      errorPlazoMinimo = this.state.plazoDias < simulador.plazoMin;
      errorPlazoMaximo = this.state.plazoDias > simulador.plazoMax;
      isWeekend = this.isWeekend(moment(this.state.plazo))
    }

    if( isWeekend ){
      errorPlazoFinDeSemana = true
      mensajeFechaFinDeSemana = "no puede seleccionar un fin de semana"
    }

    mensajeErrorMonto = errorMontoMin ? `Mínimo $${simulador.montoMin}` : `Máximo $${simulador.montoMax}` ;
    mensajeErrorPlazo = this.state.plazoDias <= simulador.plazoMin ? `Plazo mínimo ${simulador.plazoMin} días`: `Plazo máximo ${simulador.plazoMax} días` ;
    mensajePickerPlazoMinimo = `El plazo mínimo para un plazo fijo es de ${simulador.plazoMin} días`;
    mensajePickerPlazoMaximo = `El plazo máximo para un plazo fijo es de ${simulador.plazoMax} días`;
    
    if(this.state.monto !== null && this.state.plazoDias !== null && 
      !errorMontoMin && !errorMontoMax &&
      !errorPlazoMinimo && !errorPlazoMaximo && !isWeekend){
      disableSubmit = false
    }

    if(this.state.tipoPlazoFijo===2){
      errorPlazoMaximo = "" 
      mensajePickerPlazoMaximo = "" 
      errorMontoMax = "" 
    }

    if(this.state.tipoPlazoFijo===2 && errorMontoMin === false){
      mensajeErrorMonto = ""
    }
    if(this.state.tipoPlazoFijo===2 && this.state.plazoDias >= simulador.plazoMin){
      mensajeErrorPlazo = ""
    }

    return {
      errorMontoMin,
      errorMontoMax,
      errorPlazoMinimo,
      errorPlazoMaximo,
      mensajeErrorMonto,
      mensajeErrorPlazo,
      mensajePickerPlazoMinimo,
      mensajePickerPlazoMaximo,
      mensajeFechaFinDeSemana,
      errorPlazoFinDeSemana,
      disableSubmit
    }
  }

  render() {          
    const { classes , simulador, plazoFijoLandingPage} = this.props;
    let {mostrarDetalleSimulacion,tasa,montovencimiento,intereses} = this.getVarsContext()

    let {errorMontoMin,errorMontoMax,
        errorPlazoMinimo,errorPlazoMaximo,
        mensajeErrorMonto,mensajeErrorPlazo,
        mensajePickerPlazoMinimo,mensajePickerPlazoMaximo,
        errorPlazoFinDeSemana,mensajeFechaFinDeSemana,
        disableSubmit} = this.getErrorMessages()

    const monto = ( this.state.monto === 0 )?"":this.state.monto

    let displayDetallePlazoFijo = (mostrarDetalleSimulacion)?"flex":"none"

    let displayDetalleUva = (mostrarDetalleSimulacion && this.state.tipoPlazoFijo === 2 && simulador.cotizacionUva !== "") ?"block":"none"
    
    if(!this.props.simulador.huboSimulacion && !this.props.simulador.huboCambios){
      //si no c corrió ninguna simulacion remuevo la validacion sobre el formulario
      errorMontoMin = errorMontoMax = errorPlazoMinimo = errorPlazoMaximo = false
    }

    
    return (
      <div>
        <Card className={classes.card + " card-simulacion card-simulador"}>
          <CardContent>
            <Grid className={classes.selectPlazoFijoTipo} container alignItems="center" justify="flex-start" direction="row">
              <Grid item xs={12} md={8} >
                <FormControl fullWidth>
                    <InputLabel htmlFor="tipoPlazoFijo">Tipo</InputLabel>
                    <Select
                        style={{textAlign:"left"}}
                        fullWidth
                        onChange={this.handleChange}
                        validators={['required']}
                        value={this.state.tipoPlazoFijo}
                        inputProps={{
                            name: 'tipoPlazoFijo',
                            id: 'tipoPlazoFijo',
                            name: 'tipoPlazoFijo'
                        }}
                    >
                        {
                            this.state.tiposPlazoFijo.map((versionDocumento, key) => (
                                <MenuItem key={key} value={versionDocumento.id}>
                                    {versionDocumento.descripcion}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid container direction="row" justify="space-between" >
              <Grid item xs={12} md={3}  className={classes.plazoDiasEspacioMobile}>
                <TextField
                  error={errorMontoMin || errorMontoMax}
                  helperText= {mensajeErrorMonto}                  
                  value={monto}
                  onChange={this.handleChange}
                  fullWidth
                  autocomplete="off"
                  name="monto"
                  label="Monto"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    className: classes.input
                  }}
                  InputLabelProps={{
                    className: classes.montoPlazoFechaLabel
                  }}
                  FormHelperTextProps={{
                    className: classes.montoPlazoFechaHelperText
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3} className={classes.plazoDiasEspacioMobile}>
                <TextField  type="number" 
                  value={this.state.plazoDias}
                  onChange={this.handleChange}
                  name='plazoDias'
                  label="Plazo en días"
                  fullWidth
                  helperText={mensajeErrorPlazo}
                  error={errorPlazoMaximo || errorPlazoMinimo}
                  InputProps={{
                    className: classes.input,
                    startAdornment: <InputAdornment position="start"></InputAdornment>
                  }}
                  InputLabelProps={{
                    className: classes.montoPlazoFechaLabel
                  }}
                  FormHelperTextProps={{
                    className: classes.montoPlazoFechaHelperText
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3} >
                <MuiPickersUtilsProvider
                  utils={MomentUtils}
                  locale={this.state.locale}
                  moment={moment}>
                    <MuiThemeProvider>
                      <InlineDatePicker
                        error={errorPlazoFinDeSemana}
                        helperText={mensajeFechaFinDeSemana}
                        value={ this.state.plazo }
                        keyboard
                        className={classes.picker}
                        invalidDateMessage="El formato de la fecha es inválida"
                        minDateMessage={mensajePickerPlazoMinimo}
                        maxDateMessage={mensajePickerPlazoMaximo}
                        invalidLabel="El formato de la fecha es inválida"
                        shouldDisableDate={(event) => this.isWeekend(event)}
                        minDate={moment().add(simulador.plazoMin, 'days')}
                        maxDate={moment().add(simulador.plazoMax, 'days')}
                        onlyCalendar
                        label="Fecha"
                        format="DD/MM/YYYY"
                        onChange={this.handleChangeDate}
                        
                        InputProps={{
                          className: classes.input
                        }}
                        InputLabelProps={{
                          className: classes.montoPlazoFechaLabel + " " + classes.fechaLabelMobile
                        }}
                        FormHelperTextProps={{
                          className: classes.montoPlazoFechaHelperText
                        }}
                      />
                    </MuiThemeProvider>
                </MuiPickersUtilsProvider>
                <ModalNoLaborable action={this.cerrarModal} open={this.state.errorDiaNoLaborable} />
              </Grid>
              
              <Grid container alignItems="center" justify="flex-start" direction="row">
                  <Grid item xs={12} md={6} >
                    <Button className={classes.botonSimular} color="primary" onClick={this.handleSimulacion2} disabled={disableSubmit}>
                      {this.getTextoBoton()}
                    </Button>
                  </Grid>
                </Grid>
                
                <Grid style={{display:displayDetallePlazoFijo}} container spacing={8} className={classes.simulador + " form-container total"}>
                  
                  <Grid container item xs={12} sm={12} md={12} className="totales totales-simulador-final">
                    
                    <Grid item xs={12} md={6} style={{display:displayDetalleUva}}>
                      <span className={classes.interesMontoTna + " " + classes.interesCobrar}>
                        Cotización UVA
                      </span>
                      <br/>
                      <span className={classes.alignItemRight + " " + classes.interesSimulador}>
                        $ {Math.round(simulador.cotizacionUva * 100) / 100}
                      </span>
                    </Grid>

                    <Grid item xs={12} md={6} style={{display:displayDetalleUva}}>
                      <span className={classes.interesMontoTna + " " + classes.interesCobrar}>
                        Monto inicial en UVAs
                      </span>
                      <br/>
                      <span className={classes.alignItemRight + " " + classes.interesSimulador}>
                        UVA {Math.round(simulador.montoInicialUva * 100) / 100}
                      </span>
                    </Grid>

                  </Grid>

                  <Grid container item xs={12} sm={12} md={12} className="totales totales-simulador-final">
                    <Grid item xs={12} md={6}>
                      <span className={classes.interesMontoTna + " " + classes.interesCobrar}>
                        Intereses a cobrar
                      </span>
                      <br/>
                      <span className={classes.alignItemRight + " " + classes.interesSimulador}>
                        $ {Math.round(intereses * 100) / 100}
                      </span>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <span className={classes.interesMontoTna + " " + classes.interesCobrar}>
                        Monto al vencimiento
                      </span>
                      <br/>
                      <span className={classes.alignItemRight + " " + classes.interesSimulador}>
                        $ {Math.round(montovencimiento * 100) / 100}
                      </span>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} sm={12} md={6} className="totales">
                    <Grid container className="tna" alignItems="flex-end" direction="row" className={classes.interesMontoTna + " " + classes.tnaSimulador}>
                      <Grid item item xs={6} sm={5} md={2} lg={1}>
                        TNA
                      </Grid>
                      <Grid item container xs={6} sm={7} md={3} lg={2} justify="flex-end" className={classes.alignItemRight}>
                        {tasa}%
                      </Grid>
                    </Grid>
                  </Grid>
              </Grid>
              

            </Grid>
            
          </CardContent>
        </Card>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return ({
    plazoFijoLandingPage: state.plazoFijoLandingPage,
    plazoFijoInformacionDomicilio: state.plazoFijoInformacionDomicilio,
    simulador: state.plazoFijoSimulador,
    estadoLocal: 'PLAZO_FIJO_SIMULADOR'
  });
}

const mapDispatchToProps = {
  setValorCampoSimulador,
  setPlazoDiasSimulador,
  setRespuestaSimularSimulador,
  setParametriaSimulador,
  resetSimulador
}

 

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true }) 
              ( withRouter( withStyles(styles) (Simulador) ) );






// WEBPACK FOOTER //
// ./src/components/PlazoFijo/datosPersonales/Simulador.js